import React from 'react'
import PropTypes from 'prop-types'
import { Image } from 'react-bootstrap';
import img from '../../assets/IntellectualPoint-JobBoard.png';
import styled from 'styled-components';

const CircleImageBorder = styled.div`
    background: #f9f9f9;
    width:100px;
    height:100px;
    border-radius: 50%;
    border: 1px solid lightcyan;
    margin-left: 30%
`;

const Logo = styled(Image)`
    height: 30px;
    margin-top: 36px;
    margin-left: 5px;
    
    ${props => props.isDefault} {
        height: 100px;
        width: 100px;
        margin: 0%;
    }

`;

function CircleImage({imgUrl, isDefault}) {
    return (
        <CircleImageBorder>
            <Logo src={imgUrl} isDefault={isDefault} />
        </CircleImageBorder>
    )
}

CircleImage.propTypes = {

}

export default CircleImage

